var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"text-right"},[_c('otif-button',{attrs:{"className":"secondary"}},[_vm._v("Cancel")]),_c('otif-button',{attrs:{"className":"primary"},on:{"click":_vm.save}},[_vm._v("Save")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }